<template>
  <a-dropdown overlayClassName="menu-transform-drop-overlay" :trigger="['click']">
    <span class="right-content__action">
      <icon-font type="gb-icon-shuangmoshiqiehuan" />
      <span style="padding: 0 8px 0 4px">{{ changeMenuName }}</span>
      <a-icon type="down" />
    </span>
    <a-menu slot="overlay" style="top: -4px">
      <a-menu-item
        :class="{'overlay-menu-item-cur': item.id === menuCur}"
        v-for="(item, index) in [{ pageTypeName: '全部菜单', pageTypeNameEn: 'Initial Menu', pageTypeNameKr: '초기 메뉴', id: undefined}, ...menus]"
        :key="item.id"
        @click="menuChange(item.id)"
      >
        <icon-font type="gb-icon-fanhui" v-if="index === 0" style="color:#747474" />
        <img style="display:inline-block; vertical-align: middle" v-else-if="index !== 0 && item.typeIcon" :src="item.typeIcon" width="14" alt="">
        {{item['pageTypeName' + langCodes[currentLang]] || item['pageTypeName']}}
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { queryPageTypeList, selectPageType } from '@/api/sso/pageTypeInfo'

export default {
  name: 'MenuTransform',
  data () {
    return {
      menus: [],
      menuCur: '',
      langCodes: {
        'zh_CN': '',
        'en_US': 'En',
        'ko_KR': 'Kr'
      }
    }
  },
  computed: {
    ...mapGetters([
      'systemCode',
      'serviceId',
      'microApps',
      'currentLang'
    ]),
    changeMenuName () {
      return this.menus.find(plan => plan.id === this.menuCur)?.['pageTypeName' + this.langCodes[this.currentLang]] || this.$t('layouts.menutransformation')
    }
  },
  methods: {
    menuChange (id) {
      selectPageType({ id }).then(() => {
        window.location.reload(false)
      })
    }
  },
  watch: {
    serviceId: {
      handler: function (val) {
        if (!val) return
        const { systemCode, serviceId } = this
        queryPageTypeList({ paging: false, systemCode, serviceId }).then(({ data }) => {
          this.menus = data || []
          this.menuCur = this.menus.find(item => item.selectFlag === 2)?.id || undefined
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="less">
.menu-transform-drop-overlay {
  .ant-dropdown-menu {
    overflow: auto;
  }
  .ant-dropdown-menu-item {
    padding: 8px 12px;
    line-height: 20px;
    img {
      display: inline-block;
      vertical-align: top;
      margin-right: 3px;
    }
    .anticon {
      font-size: 14px !important;
      margin-right: 5px !important;
    }
  }
  &::after{
    position: absolute;
    content: '';
    display: block;
    border: 6px transparent solid;
    border-bottom: 6px #fff solid;
    top: -15px;
    left: 50px;
    margin-left: -6px;
    z-index: 4;
    transition: all 0.1;
  }
  .overlay-menu-item-cur {
    background: #e6f7ff
  }
}
</style>
<style lang="less" scoped>
.right-content__action {
  position: relative;
  &::after {
    position: absolute;
    display: block;
    content: '';
    border-right: 1px #fff solid;
    height: 14px;
    right: 0px;
    top: 50%;
    margin-top: -7px;
  }
}
</style>
